<section class="bg-rgb spacer-pt-space spacer-pb-space">
    <div class="container">
        <div class="mb-[55px]">
            <app-image-card [imageCardData]="imageCardData"></app-image-card>
        </div>
        <div>
            <div class="mb-8 ">
                <img [ngSrc]="assetsCDNUrl+'/assets/images/home-page/shriram-group.webp'"
                    class="mb-6 w-[115px] md:w-[140px] xxl:w-auto" alt="shriram-welath" width="202" height="62"
                    loading="lazy">
                <div class="grid grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-[14px] md:gap-8">
                    @for (card of items; track $index) {
                    <div class="arrowImage bg-white  px-2 py-5 md:p-5 min-h-[110px] md:min-h-[150px] xxl:min-h-[185px] h-full flex justify-center flex-col relative"
                        style="box-shadow: 0px 4px 9.1px 0px rgba(0, 0, 0, 0.15);">

                        <div class="flex items-center gap-1">
                            @if(card.headingBasic){
                            <span
                                class="text-18 md:text-26 xxl:text-30 font-libre-regular mb-2 md:mb-3">{{card.headingPre}}</span>
                            <p class="text-18 md:text-26 xxl:text-30 font-libre-regular mb-2 md:mb-3">{{card.heading}}
                            </p>
                            <span
                                class="text-18 md:text-26 xxl:text-30 font-libre-regular mb-2 md:mb-3">{{card.headingPost}}</span>
                            }
                            @else {
                            @if(delay){
                            <span
                                class="text-18 md:text-26 xxl:text-30 font-libre-regular mb-2 md:mb-3">{{card.headingPre}}</span>
                            }
                            <p class="text-18 md:text-26 xxl:text-30 font-libre-regular mb-2 md:mb-3 pointer-events-none"
                                [countUp]="card.heading" [options]="opts1"> </p>
                            @if(delay){
                            <span
                                class="text-18 md:text-26 xxl:text-30 font-libre-regular mb-2 md:mb-3">{{card.headingPost}}</span>
                            }
                            }
                        </div>
                        <p class="mb-0 text-12  md:text-16 xxl:text-18 text-[#454545]">{{card.para}}</p>
                    </div>
                    }
                </div>
            </div>
            <p class="text-right text-12 mb-8 md:mb-[45px]">Data published as on March 2025</p>

            <div class="mb-8 ">
                <img [ngSrc]="assetsCDNUrl+'/assets/images/sanlam.svg'" class="mb-6 w-[115px] md:w-[140px] xxl:w-auto"
                    alt="shriram-welath" width="202" height="62" loading="lazy">
                <div class="grid grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-[14px] md:gap-8">
                    @for (card of cardItem; track $index) {
                    <div class="arrowImage bg-white  px-2 py-5 md:p-5 min-h-[110px] md:min-h-[150px] xxl:min-h-[185px] h-full flex justify-center flex-col relative"
                        style="box-shadow: 0px 4px 9.1px 0px rgba(0, 0, 0, 0.15);">
                        <div class="flex items-center gap-1">

                            @if(card.headingBasic){
                            <span
                                class="text-18 md:text-26 xxl:text-30 font-libre-regular mb-2 md:mb-3">{{card.headingPre}}</span>
                            <p class="text-18 md:text-26 xxl:text-30 font-libre-regular mb-2 md:mb-3">{{card.heading}}
                            </p>
                            <span
                                class="text-18 md:text-26 xxl:text-30 font-libre-regular mb-2 md:mb-3">{{card.headingPost}}</span>
                            }
                            @else {
                            @if(delay){
                            <span
                                class="text-18 md:text-26 xxl:text-30 font-libre-regular mb-2 md:mb-3">{{card.headingPre}}</span>
                            }
                            <p class="text-18 md:text-26 xxl:text-30 font-libre-regular mb-2 md:mb-3 pointer-events-none"
                                [countUp]="card.heading" [options]="opts"> </p>
                            @if(delay){
                            <span
                                class="text-18 md:text-26 xxl:text-30 font-libre-regular mb-2 md:mb-3">{{card.headingPost}}</span>
                            }
                            }


                        </div>
                        <p class="mb-0 text-12  md:text-16 xxl:text-18 text-[#454545]">{{card.para}}</p>
                        <!-- <p class="mt-1 text-10 md:text-11 mb-0">{{card.subText}}</p> -->

                    </div>
                    }
                </div>
            </div>
            <p class="text-right text-12 mb-0">Data published as on 31<sup>st</sup> December 2024</p>
            <p class="text-right mt-1 text-12  mb-0"><sup>*</sup>Rand = INR 4.53 as on 29<sup>th</sup> December 2024</p>

        </div>

    </div>
</section>